// extracted by mini-css-extract-plugin
module.exports = {"specification-table-div":"specification-table-div-da477cd6dc384f6bc8cc46cd1061bf4d","specification-table":"specification-table-1cab23c370cd4cf024a8348a46155fd0"};